// import firebase from "../firebase";
import { firestore } from "../firebase";

// const db = firebase.collection("/tutorials");
const db = firestore.collection("/tutorials");
const dbShopsLength = firestore.collection("/shopsLength");

class TutorialDataService {
  getAll() {
    return db;
  }

  create(tutorial) {
    return db.add(tutorial);
  }

  update(id, value) {
    return db.doc(id).update(value);
  }

  updateComments(tid, cid, value) {
    return db.doc(tid).collection("comments").doc(cid).update(value);
  }

  setId(tid, data) {
    dbShopsLength
      .doc("ids")
      .get()
      .then(async (doc) => {
        const length = doc.data().length + 1;
        await dbShopsLength.doc("ids").set({ length });
        await db.doc(tid).set({ ...data, uniqueId: length });
      });
  }

  delete(id) {
    return db.doc(id).delete();
  }
}

export default new TutorialDataService();
